export const newRelease = {
  id: 1,
  gif1: "http://cdn.shopify.com/s/files/1/0281/3122/9834/products/LED_1200x1200.gif?v=1622162762",
  desc: "World's 1st Wireless Charging Keyboard.Inspired by Cybertruck, World's 1st Wireless Charging Custom LED Mechanical Keyboard."
};
